import React from 'react';
import { compose, is } from 'ramda';
import moment from 'moment';
import { List, Map, merge } from 'immutable';

import styleFile from './AvailSummarySendMail.js';
import RichText from '@synergycms_core/components/generic/RichText';
import Form from '@synergycms_core/components/generic/Form';
import InputField from '@synergycms_core/components/generic/Form/InputField.jsx';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Tabs, { Tab } from '../../generic/TabList';
import { Button, Image } from '@synergycms_core/components/generic/';
import { getReservationTotals } from '../../../utils';
import api from '@synergycms_core/utils/api';
import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';
import { connect } from 'react-redux';

export const SendSelectionButton = compose(
  withThemeJSS({ styleFile, displayName: "AvailSummarySendMail" }))(props => {
    const { classes } = props.theme.styles;
    return (
      <div className={classes.sendContainer}>
        <Button
          id={props.currentStep || 'td-d2-send-summary-00'}
          richText={{
            text: '_%enviar selección%_',
            icon: {
              unicodeContent: 'e158',
              innerStyle: ['size20', 'marginRight5']
            },
            innerStyle: ['uppercase',classes.buttonTextStyle],
            translate: true
          }}
          onClick={props.toggleSendMailForm}
          innerStyle={['toggleMainButtonReverse', 'summarySendAvail']}
        />
      </div>
    )
  });

  const checkIdParams = (step,param, type) => {
    switch (step) {

      case 'serviceHotelAvail' :
        return param & type ? 'td-d2-send-inactivity-01' : param & !type ? 'td-d2-send-inactivity-02' : !param & type ? 'td-d2-send-summary-01' : 'td-d2-send-summary-02'

      case 'customerForm' :
        return param & type ? 'td-d3-send-inactivity-01' : param & !type ? 'td-d3-send-inactivity-02' : !param & type ? 'td-d2-send-summary-01' : 'td-d2-send-summary-02'

      default:
        break;
    }
  };

const AvailMailSuccess = props => (
  <div className={props.classes.sendMailContent}>
    <div className={props.classes.header}>
      <RichText
        text={'_%mail enviado correctamente!%_'}
        ucFirst={true}
        innerStyle={['roboto16BoldBlack']}
        translate={true}
      />
      <Button
        onClick={props.toggleSendMailForm}
        innerStyle={[props.classes.closeButton, 'gold']}
        icon={{ unicodeContent: 'e001' }}
        defaultStyle={false}
        ariaLabel={'_%mail enviado correctamente!%_'}
        translate={true}
      />
    </div>
  </div>
);

const SendMailToMyself = props => (
  <Form
    innerStyle={[props.classes.row, props.classes.customerMailBlock, props.shortVersionSummary ? props.classes.shortSummary : undefined]}
    withoutForm={false}
    onSubmit={props.sendOwnAvailMail}>
    <label className={props.classes.inputBox}>
      <InputField
        model={'single_email'}
        validationsFields={{ field: 'email' }}
        validations={['required', 'email']}
        innerStyle={['inputText', props.classes.inputText]}
        defaultValue={props.placeholderUser || ''}
      />
      <InputNotify model={'single_email'} innerStyle={[props.classes.textModal]} />
      <RichText innerStyle={[props.classes.labelText]} ucFirst={true} text={'email'} translate={true} />
      <ButtonSubmit
        disableOnError={true}
        richText={{
          text: '_%enviar%_',
          translate: true,
          ucFirst:true,
          innerStyle: ['clearfix', 'toggleSecondButton', !props.shortVersionSummary ? 'uppercase' : undefined]
        }}
        innerStyle={['toggleSecondButton', props.classes.sendCustomerMailButton]}
        id={[props.idSendBtn]}
      />
    </label>
  </Form>
);

const ReservationInfoBlock = props => (
  <div className={props.classes.reservationInfoBlock}>
    <div className={props.classes.infoRow}>
      <RichText
        text={'_%entrada%_'}
        ucFirst={true}
        innerStyle={['roboto13BoldBlack', props.classes.infoCell]}
        translate={true}
      />
      <RichText
        ucFirst={true}
        innerStyle={['roboto13Black', props.classes.infoCell, props.classes.infoCellRight]}
        text={moment(props.reservationRequest.get('checkin')).format('dddd, D MMMM [de] YYYY')}
        translate={true}
      />
    </div>
    <div className={props.classes.infoRow}>
      <RichText
        ucFirst={true}
        text={'_%salida%_'}
        innerStyle={['roboto13BoldBlack', props.classes.infoCell]}
        translate={true}
      />
      <RichText
        ucFirst={true}
        innerStyle={['roboto13Black', props.classes.infoCell, props.classes.infoCellRight]}
        text={moment(props.reservationRequest.get('checkout')).format('dddd, D MMMM [de] YYYY')}
        translate={true}
      />
    </div>
    <div className={props.classes.infoRow}>
      <RichText
        plural={true}
        ucFirst={true}
        text={'_%noche%_'}
        innerStyle={['roboto13BoldBlack', props.classes.infoCell]}
        translate={true}
      />
      <span className={[props.classes.infoCell, props.classes.infoCellRight].join(' ')}>
        <RichText
          innerStyle={['roboto13Black']}
          text={
            moment(props.reservationRequest.get('checkout')).diff(
              moment(props.reservationRequest.get('checkin')),
              'days'
            ) + ' '
          }
        />
        <RichText
          innerStyle={['roboto13Black']}
          quantity={moment(props.reservationRequest.get('checkout')).diff(
            moment(props.reservationRequest.get('checkin')),
            'days'
          )}
          text={'_%noche%_'}
          translate={true}
          ucFirst={true}
        />
      </span>
    </div>
    <div className={props.classes.infoRow}>
      <RichText
        plural={true}
        text={'_%huésped%_'}
        ucFirst={true}
        innerStyle={['roboto13BoldBlack', props.classes.infoCell]}
        translate={true}
      />
      <div className={[props.classes.infoCell, props.classes.infoCellRight, props.classes.paxBlock].join(' ')}>
        <span>
          <Image unicodeContent="e0be" innerStyle={['gold']} />
          {props.totalAdults}{' '}
          <RichText
            quantity={props.totalAdults}
            text={'_%adulto%_'}
            innerStyle={['roboto13Black']}
            ucFirst={true}
            plural={true}
            translate={true}
          />
        </span>
        {props.totalChilds ? (
          <span className={props.classes.childContainer}>
            <Image unicodeContent="e0be" innerStyle={['gold', 'size11']} />
            {props.totalChilds}{' '}
            <RichText
              quantity={props.totalChilds}
              text={'_%niño%_'}
              innerStyle={['roboto13Black']}
              plural={true}
              translate={true}
              ucFirst={true}
            />
          </span>
        ) : (
            ''
          )}
      </div>
    </div>
  </div>
);

const AvailSummarySendMail = class AvailSummarySendMail extends React.Component {
  static displayName = 'AvailSummarySendMail';

  constructor(props) {
    super(props);
    this.state = {
      sendMailForm: true,
      mailSuccess: false
    };

    this.toggleSendMailForm = props.config.callbackButtonForm
      ? props.config.callbackButtonForm
      : this.toggleSendMailForm.bind(this);
  }

  toggleSendMailForm = e => {
    e && e.preventDefault();
    this.setState(state => ({
      sendMailForm: !state.sendMailForm,
      mailSuccess: false
    }));
  };

  toggleMailSuccess = success => {
    const { callbackSuccess } = this.props.config;
    if (callbackSuccess) {
      this.toggleSendMailForm();
      callbackSuccess(success);
    } else {
      this.setState(
        {
          mailSuccess: success
        },
        () => {
          if (this.state.mailSuccess) {
            setTimeout(() => {
              this.setState({
                sendMailForm: true,
                mailSuccess: false
              });
            }, 1000);
          }
        }
      );
    }
  };

  buildMailRedirectUrl = () => {
    // TODO : arreglar aquesta b*****
    return (' ' + window.location.href).slice(1);
    /*const hrefCopy = (' ' + window.location.href).slice(1);
    const strPos = hrefCopy.indexOf('#');
    const encodedParams = '&resRequest=' + btoa(JSON.stringify(this.props.config.reservationRequest.get('blocks')));

    return splice(hrefCopy, strPos, 0, encodedParams);*/
  };

  sendOwnAvailMail = (validForm, inputList) => {
    const requestBody = {
      customersInfo: inputList,
      reservationRequest: this.props.config.reservationRequest,
      reservationTotals: this.props.config.reservationTotals || false,
      redirectUrl: this.buildMailRedirectUrl(),
      toAcquaintance: false
    };
    this.toggleMailSuccess(true);
    return api.post('cms/send_avail_mail', requestBody, this.props.config.hotelId).then(function (res) { });
  };

  sendAcquaintanceAvailMail = (validForm, inputList) => {
    const requestBody = {
      customersInfo: inputList,
      reservationRequest: this.props.config.reservationRequest,
      reservationTotals: this.props.config.reservationTotals,
      redirectUrl: this.buildMailRedirectUrl(),
      toAcquaintance: true
    };
    this.toggleMailSuccess(true);
    return api.post('cms/send_avail_mail', requestBody, this.props.config.hotelId);
  };

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const { shortVersionSummary, placeholderUser, idSendBtn, loyaltyUser } = config;

    if(shortVersionSummary){
      return !this.state.mailSuccess ?
          <SendMailToMyself
              idSendBtn={idSendBtn}
              placeholderUser={loyaltyUser ? loyaltyUser.get('email', '') : placeholderUser}
              classes={classes}
              sendOwnAvailMail={this.sendOwnAvailMail}
              shortVersionSummary={shortVersionSummary}/> : (
        <AvailMailSuccess classes={classes} toggleSendMailForm={this.toggleSendMailForm} />
      );
    } else {
      return this.state.sendMailForm && !config.callbackButtonForm ? (
        <SendSelectionButton classes={classes} toggleSendMailForm={this.toggleSendMailForm} />
      ) : !this.state.mailSuccess ? (
        <div className={classes.sendMailContent}>
          <div className={classes.header}>
            <RichText
              text={'_%enviar detalles de la seleccion%_'}
              innerStyle={['roboto16BoldBlack']}
              ucFirst={true}
              translate={true}
            />
            <Button
              onClick={this.toggleSendMailForm}
              innerStyle={[classes.closeButton, 'gold']}
              icon={{ unicodeContent: 'e001' }}
              defaultStyle={false}
              ariaLabel={'_%enviar detalles de la seleccion%_'}
              translate={true}
            />
          </div>
          <Tabs titleBlockStyle={classes.titleListBlock} contentBlockStyle={classes.contentBlock}>
            <Tab
              contentKey={1}
              tabTitle={{
                richText: {
                  innerStyle: ['uppercase'],
                  translate: true,
                  text: '_%enviar a tu correo%_'
                },
                innerStyle: [classes.tabTitle, 'capitalize']
              }}>
              <SendMailToMyself classes={classes} sendOwnAvailMail={this.sendOwnAvailMail} placeholderUser={loyaltyUser ? loyaltyUser.get('email', '') : placeholderUser}/>
            </Tab>
            <Tab
              contentKey={2}
              tabTitle={{
                richText: {
                  innerStyle: ['uppercase'],
                  translate: true,
                  text: '_%enviar a un amigo%_'
                },
                innerStyle: [classes.tabTitle, classes.noBorder]
              }}>
              <Form
                innerStyle={[classes.row, classes.acquaintanceMailBlock].join(' ')}
                withoutForm={false}
                onSubmit={this.sendAcquaintanceAvailMail}>
                <label className={classes.inputBox}>
                  <InputField
                    model={'own_name'}
                    validationsFields={{ field: 'tu nombre' }}
                    validations={['required']}
                    innerStyle={['inputText', classes.inputText]}
                    css={{ invalid: 'lol' }}
                  />
                  <InputNotify model={'own_name'} />
                  <RichText innerStyle={[classes.labelText]} ucFirst={true} text={'_%tu nombre%_'} translate={true} />
                </label>
                <label className={[classes.inputBox]}>
                  <InputField
                    model={'acquaintance_name'}
                    validationsFields={{ field: 'nombre de tu amigo' }}
                    validations={['required']}
                    innerStyle={['inputText', classes.inputText]}
                    css={{ invalid: 'lol' }}
                  />
                  <InputNotify model={'acquaintance_name'} />
                  <RichText
                    innerStyle={[classes.labelText]}
                    ucFirst={true}
                    text={'_%nombre de tu amigo%_'}
                    translate={true}
                  />
                </label>
                <label className={[classes.inputBox]}>
                  <InputField
                    model={'acquaintance_email'}
                    validationsFields={{ field: 'email de tu amigo' }}
                    validations={['required', 'email']}
                    innerStyle={['inputText', classes.inputText]}
                    css={{ invalid: 'lol' }}
                  />
                  <InputNotify model={'acquaintance_email'} />
                  <RichText
                    innerStyle={[classes.labelText]}
                    ucFirst={true}
                    text={'_%email de tu amigo%_'}
                    translate={true}
                  />
                </label>
                <div className={[classes.submitButtonsBox]}>
                  <label>
                    <Button
                      onClick={this.toggleSendMailForm}
                      richText={{
                        text: '_%cancelar_2%_',
                        translate: true,
                        innerStyle: ['clearfix', 'toggleSecondButton', 'uppercase'],
                        icon: {
                          unicodeContent: 'e001',
                          innerStyle: ['size10', 'marginRight15']
                        }
                      }}
                      innerStyle={['toggleMainButtonReverse', classes.dismissMailButton]}
                    />
                  </label>
                  <label>
                    <ButtonSubmit
                      id={checkIdParams(this.props.config.currentStep,this.state.sendMailForm, false)}
                      disableOnError={true}
                      richText={{
                        text: '_%enviar%_',
                        translate: true,
                        innerStyle: ['clearfix', 'toggleSecondButton', 'uppercase']
                      }}
                      innerStyle={['toggleSecondButton', classes.sendMailButton]}
                    />
                  </label>
                </div>
              </Form>
            </Tab>
          </Tabs>
          <ReservationInfoBlock
            classes={classes}
            reservationRequest={config.reservationRequest}
            totalAdults={config.totalAdults}
            totalChilds={config.totalChilds}
          />
        </div>
      ) : (<AvailMailSuccess classes={classes} toggleSendMailForm={this.toggleSendMailForm} />);
    }
  }
};

const mapStateToProps = (store, ownProps) => {
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const currentStep = ownProps.currentStep;
  const loyaltyUser = store.getIn(['customer', 'loyalty', 'user'], false);
  const corporateUser = store.getIn(['customer', 'corporate'], false);

  let totalAdults = ownProps.totalAdults;
  let totalChilds = ownProps.totalChilds;
  let childsInfo = ownProps.childsInfo;
  let idSendBtn = 'td-d0-send-inactivity-00';
  if (!totalAdults) {
    totalAdults = 0;
    totalChilds = 0;
    const hotelAvail = store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', 'string_query_params']),
      'response'
    ]);
    if (reservationBlocks) {
      reservationBlocks.forEach(block => {
        const roomAvail = hotelAvail && hotelAvail.getIn([block.get('idx') - 1, block.get('room_id')]);
        totalAdults += roomAvail && roomAvail.get('adults', 0);
        totalChilds += roomAvail && roomAvail.get('childs', 0);
      });
    }
  }

  let reservationRequest;
  if(reservationBlocks) {
      if(loyaltyUser) {
          reservationRequest = store.getIn(['customer', 'reservation_request']).set('loyalty', loyaltyUser);
      } else if(corporateUser) {
          reservationRequest = store.getIn(['customer', 'reservation_request']).set('corporate', corporateUser);
      }
  } else {
    if(loyaltyUser) {
      reservationRequest = Map(merge(
        ownProps.reservationRequest,
        store.getIn(['customer', 'reservation_request']).set('loyalty', loyaltyUser)
      ));
    } else {
      reservationRequest = Map(ownProps.reservationRequest);
    }
  }

  switch (currentStep) {
    case 'customerForm':
      idSendBtn = 'td-d3-send-inactivity-00';
      break;
    case 'serviceHotelAvail':
      idSendBtn = 'td-d2-send-inactivity-00';
      break;
    case 'monoHotelAvail':
      idSendBtn = 'td-d1-send-inactivity-00';
      break;
    default:
      idSendBtn = 'td-d0-send-inactivity-00';
      break;
  }

  return {
    hotelConfig : contextualizeAppConfig(store, hotelId),
    hotelId: hotelId,
    totalAdults: totalAdults,
    totalChilds: totalChilds,
    childsInfo : childsInfo,
    reservationTotals:
    reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store),
    reservationRequest: reservationRequest,
    idSendBtn: idSendBtn,
    loyaltyUser: loyaltyUser
  };
};

export default compose(
  connect(mapStateToProps),
  PropertyManager([
    'reservationRequest',
    'reservationTotals',
    'stepCode',
    'callbackButtonForm',
    'callbackSuccess',
    'hotelId',
    'totalAdults',
    'totalChilds',
    'childsInfo',
    'shortVersionSummary',
    'placeholderUser',
    'idSendBtn',
    'loyaltyUser',
    'hotelConfig'
  ]),
  withThemeJSS({ styleFile, link: true })
)(AvailSummarySendMail);
